<template>
  <div class="top-vedio" :style="{height:height}" >
    <NovoVideo  src="/static/video/novovedio.mp4" width="100%"  @canplaythrough="canplaythrough" :delayTime="800" :poster="require('common/image/home/top-vedio/backtop.png')" />
     
    <div :class="{textBox: true}">
      <LazyLoading>
      <div class="text goUp">
        <h1 class="title">智能办公门禁管理系统</h1>
        <h2 class="descript">NOVOBIT不仅仅是门禁管理系统，</h2>
        <h2 class="descript">它能为您提供更智能的会议室管理方案，更加灵活的人员出入权限管理。</h2>
        <router-link to="/contactus" style="margin-top:60px;">
          <div class="btn">
            联系我们
          </div>
        </router-link>
      </div>
      </LazyLoading>
    </div>
  </div>
</template>

<script>

  import HomeTopimg from 'common/image/home/top-vedio/backtop.png';
  import { debug } from 'util';
  import {LazyLoading,NovoVideo} from 'novo-ui'

  export default {
    name: "TopVedio",
    components: {
      LazyLoading,
      NovoVideo
    },
    data() {
      return {
        HomeTopimg,
        height:'100vh'
      };
    },
    mounted() {
    },
    methods: {
      canplaythrough(){
        this.height='auto';
      }
    }
  };
</script>
<style scoped lang="scss">

  .top-vedio{
    position: relative;
    font-size: 0;
    overflow: hidden;
    max-height: 100vh;
    // max-height: 100vh;
    .textBox{
      // visibility: hidden;
      position: absolute;
      top:0;
      left:0;
      width:100%;
      height:100%;
      // padding-top:238px;
      background: rgba(255,255,255,0.50);
      .text{
        width: 1060px;
        position: absolute;
        left: 50%;
        top: 50%;
        // transform: translateY(-50%) translateX(-50%);
        margin: -130px -530px;
        // visibility: hidden;
        a{
          display:block;
          margin:0 auto;
          width: 180px;
          height: 60px;
          line-height: 60px;
          text-align: center;
          background-image: linear-gradient(-135deg, #3CA9FF 0%, #7CE1FF 100%);
          border-radius: 30px;
          font-family: DFPKingGothicGB-Medium;
          font-size: 24px;
          color: #FFFFFF;
          cursor: pointer;
          &:active{
            box-shadow: 4px 4px 20px #908d8d;
          }
        }
      }
      h1,h2{
        text-align: center;
        font-weight: 400;
      }
     
      .title{
        font-family: DFPKingGothicGB-Regular;
        font-size: 36px;
        color: #323232;
        text-align: center;
        height:44px;
        line-height:44px;
        margin-bottom:60px;
        font-weight: bold;
      }
      .descript{
        font-family: DFPKingGothicGB-Regular;
        font-size: 24px;
        color: #323232;
        text-align: center;
        height:24px;
        line-height:24px;
        margin-bottom:35px;

      }
    }
  }



</style>



// WEBPACK FOOTER //
// src/pages/home/top-vedio/index.vue